import { ITextControlProperties } from '../entities/ITextControlProperties';
import EditControl from './EditControl';
import { IPropertyField } from '../../../entities/common';
import { IDictionary } from '@bimser/core';
import { JSX } from 'react';

export default class TextControl extends EditControl<string> {
	maxLength: number;
	isSecretData: boolean;

	constructor() {
		super();

		this.maxLength = 50;
		this.isSecretData = false;
	}

	__loadProperties(data: ITextControlProperties) {
		super.__loadProperties(data);

		this.__proxyChanged.maxLength = data.maxLength;
		this.__proxyChanged.isSecretData = data.isSecretData;
	}

	__getPropertyFields(): IPropertyField[] {
		const fields = super.__getPropertyFields();
		return [
			...fields,
			{
				name: 'value',
				type: 'string',
				common: true
			},
			{
				name: 'maxLength',
				type: 'number'
			},
			{
				name: 'isSecretData',
				type: 'boolean'
			}
		];
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			maxLength: this.maxLength,
			isSecretData: this.isSecretData
		};
	}
	__render(children?: React.ReactNode): JSX.Element {
		return super.__render(children);
	}
}
